module.exports = __webpack_public_path__ + "img/favicon_blue_cut.f41e8362.svg";